import { sendNewProcessByEmail } from "./services/process.service";
import { validateAndSendForm } from "./utils/form.util";

const rules = (inputs) => {
  const [nameInput, emailInput, phoneInput, rfcInput] = inputs;
  return [
    {
      field: `${nameInput}`,
      rules: [
        { rule: "required", errorMessage: "Por favor, ingresa tu nombre." },
        {
          rule: "minLength",
          value: 3,
          errorMessage: "El nombre debe tener al menos 3 caracteres.",
        },
      ],
    },
    {
        field: `${emailInput}`,
        rules: [
          {
            rule: "required",
            errorMessage: "El correo electrónico es obligatorio.",
          },
          {
            rule: "email",
            errorMessage: "Ingresa un correo electrónico válido.",
          },
        ],
      },
    {
      field: `${phoneInput}`,
      rules: [
        { rule: "required", errorMessage: "El teléfono es obligatorio." },
        {
          rule: "customRegexp",
          value: /^[0-9]{10}$/,
          errorMessage: "Debe ser un número de 10 dígitos.",
        },
      ],
    },
    {
      field: `${rfcInput}`,
      rules: [
        { rule: "required", errorMessage: "El rfc no puede estar vacío." },
        // {
        //   rule: "minLength",
        //   value: 13,
        //   errorMessage: "El mensaje debe tener al menos 13 caracteres.",
        // },
      ],
    },
  ];
};

const openEkatenaInNewTab = () => {
  const ekatenaUrl = process.env.ARK_EKATENA_URL;
  if (!ekatenaUrl) {
    console.error('EKATENA URL is not defined.');
    return;
  }
  window.open(ekatenaUrl, '_blank');
};

export const sendProcessForm = (form) => {
  validateAndSendForm(form, rules, sendNewProcessByEmail, (wasSendForm) => {
    if (wasSendForm) {
      openEkatenaInNewTab();
    }
  });
};
